// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import loadCurrentAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import {
    getallowBillToAddressEdit,
    getallowShipToAddressEdit,
    getCanShowInventory,
    getGreifInvoiceExportSettings,
    getGreifOrderHistoryExportSettings,
    getIsAccessoryUpsellEnabled,
    getIsAuthenticated,
    getIsCartRedesignEnabled,
    getIsCheckoutTaxAlertEnabled,
    getIsMaintenanceBannerEnabled,
    getIsPackagingAdviceEnabled,
    getIsSignedInAndhasToBeSignedIn,
    getIsSimpleRequestQuoteEnabled,
    getSignInRequiredToAddToCartOrSeePrices,
} from "@store/Framework/Store/Context/ContextSelector";
import { useEffect } from "react";
import convertSelectorToHook from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const useGreifOrderHistoryExportSettings = convertSelectorToHook(getGreifOrderHistoryExportSettings);
export const useGreifInvoiceExportSettings = convertSelectorToHook(getGreifInvoiceExportSettings);
export const useIsAccessoryUpsellEnabled = convertSelectorToHook(getIsAccessoryUpsellEnabled);
export const useIsCartRedesignEnabled = convertSelectorToHook(getIsCartRedesignEnabled);
export const useIsCheckoutTaxAlertEnabled = convertSelectorToHook(getIsCheckoutTaxAlertEnabled);
export const useIsMaintenanceBannerEnabled = convertSelectorToHook(getIsMaintenanceBannerEnabled);
export const useIsPackagingAdviceEnabled = convertSelectorToHook(getIsPackagingAdviceEnabled);
export const useIsSimpleRequestQuoteEnabled = convertSelectorToHook(getIsSimpleRequestQuoteEnabled);

export const useGetSignInRequiredToAddToCartOrSeePrices = () => {
    return useAppSelector(state => getSignInRequiredToAddToCartOrSeePrices(state));
};

export const useIsSignedInAndhasToBeSignedIn = () => {
    return useAppSelector(state => getIsSignedInAndhasToBeSignedIn(state));
};

export const useCanShowInventory = () => {
    return useAppSelector(state => getCanShowInventory(state));
};

export const useCanEditShipToAddress = () => {
    return useAppSelector(state => getallowShipToAddressEdit(state));
};

export const useCanEditBillToAddress = () => {
    return useAppSelector(state => getallowBillToAddressEdit(state));
};

export const useIsAuthenticated = () => {
    return useAppSelector(state => getIsAuthenticated(state));
};

export const useHandleLoadAccount = () => {
    const isAuthenticated = useIsAuthenticated();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(loadCurrentAccount());
        }
    }, [isAuthenticated]);
};
